"use client";
import { jsx } from "react/jsx-runtime";
import { DropdownIconItem } from "../../primitive-dropdown/dropdown-icon-item.js";
import { AsyncGenericDropdown } from "./async-generic-dropdown.js";
function AsyncIconsDropdown({ icons, ...props }) {
    const options = icons.map((option)=>({
            value: option.value,
            label: option.title,
            element: (elementProps)=>/*#__PURE__*/ jsx(DropdownIconItem, {
                    icon: option,
                    ...elementProps
                })
        }));
    return /*#__PURE__*/ jsx(AsyncGenericDropdown, {
        ...props,
        options: options
    });
}
export { AsyncIconsDropdown };
